<style lang="less" scoped>
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px" class="detail-form">
                    <div class="flex detail-form-parent-div">
                        <div class="flex-1">
                            <el-form-item label="充电桩型号名称" prop="pileTypeName">
                                <el-input v-model="detailForm.pileTypeName" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="电流输出类型" prop="currentOutType">
                                <el-select class="full-width" v-model="detailForm.currentOutType" size="small" clearable>
                                    <el-option label="交流" value="01"></el-option>
                                    <el-option label="直流" value="02"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="接口类型" prop="interfaceType">
                                <el-select class="full-width" v-model="detailForm.interfaceType" size="small" clearable>
                                    <el-option label="国标" value="01"></el-option>
                                    <el-option label="欧标" value="02"></el-option>
                                    <el-option label="美标" value="03"></el-option>
                                    <el-option label="其他" value="04"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="额定电压（V）" prop="ratedVoltage">
                                <el-input v-model="detailForm.ratedVoltage" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="额定功率" prop="ratedPower">
                                <el-input v-model="detailForm.ratedPower" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="电流谐波">
                                <el-input v-model="detailForm.currentHarmonic" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="系统状态" prop="useState">
                                <el-select class="full-width" v-model="detailForm.useState" size="small" clearable>
                                    <el-option label="已使用" value="01"></el-option>
                                    <el-option label="未使用" value="02"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="flex-1">
                            <el-form-item label="型号" prop="pileTypeCode">
                                <el-input v-model="detailForm.pileTypeCode" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="充电速度" prop="chargingSpeed">
                                <el-select class="full-width" v-model="detailForm.chargingSpeed" size="small" clearable>
                                    <el-option label="快充" value="01"></el-option>
                                    <el-option label="慢充" value="02"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="充电枪数量" prop="gunNum">
                                <el-input v-model="detailForm.gunNum" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="额定电流（A）">
                                <el-input v-model="detailForm.ratedCurrent" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="稳定精度">
                                <el-input v-model="detailForm.stabilizationAccuracy" size="small"></el-input>
                            </el-form-item></div>
                    </div>
                </el-form>
            </div>
            <div class="detail-content-footer-div">
                <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                editFlag:false,
                pageTitle:'充电桩型号新增',
                // 默认值设置
                detailForm: {},
            }
        },
        methods: {
            init() {
                if(this.$store.state.editId){
                    this.editFlag = true;
                    this.pageTitle = "充电桩型号编辑";
                    this.getFormInfo();
                }
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                _.$S.getFormInfo(_,_.$A.pileType +'/'+_.$store.state.editId,function(res){
                     _.detailForm = res.data.data;
                });
            },
            // 表单提交
            submitForm(formName) {
                let _ = this;
                _.detailForm.corpNo = _.$store.state.corpNo;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.$S.submitForm(_, _.$A.pileType, _.editFlag, _.detailForm, pageConfig.listRouter);
                    }
                });
            },
            // 取消
            resetForm() {
                this.$router.push({
                    name: pageConfig.listRouter
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>